import { AxiosError } from "axios";

/**
 * The core error text, or the plain network failure, as an Error.
 *
 * A rule refusal (the compliance gate) answers with `message` and a list of
 * `findings`; every one is joined in, so none of the reasons is hidden behind
 * the first. A validation failure names its fields.
 */
export function coreError(error: unknown, fallback: string): Error {
  const err = error as AxiosError<{
    message?: string | string[];
    errors?: Record<string, string>;
    findings?: { message: string }[];
  }>;
  // A sentence this code wrote itself (not a failed request) already says what is wrong.
  if (error instanceof Error && !(error as AxiosError).isAxiosError) return error;
  const body = err?.response?.data;
  if (Array.isArray(body?.findings) && body.findings.length > 0) {
    return new Error(body.findings.map((f) => f.message).join("; "));
  }
  if (body?.errors && typeof body.errors === "object") {
    const fields = Object.entries(body.errors).map(([field, text]) => `${field}: ${text}`);
    if (fields.length > 0) return new Error(fields.join("; "));
  }
  const message = body?.message;
  if (Array.isArray(message)) return new Error(message.join(", "));
  if (typeof message === "string" && message) return new Error(message);
  if (err?.code === "ERR_NETWORK") {
    return new Error("Cannot reach the MoneeFlo API. Check your connection.");
  }
  return new Error(fallback);
}
